import { editPrescription } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  EditPrescriptionRequestT,
  PrescriptionT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchEditPrescription(
  dosespotPrescriptionId: string,
  data: EditPrescriptionRequestT,
  signal?: AbortSignal
): Promise<PrescriptionT> {
  const config = await createLotusRequestConfig({ signal });

  const response = await editPrescription(dosespotPrescriptionId, data, config);
  return lotusHealthZod.editPrescriptionResponse.parse(response.data) as PrescriptionT;
}
